import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aadabd58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basic-info" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "info-head df aic jcsb" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("span", { class: "info-head-title" }, "求职期望")
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 修改")
const _hoisted_6 = {
  key: 0,
  class: "no-explist-info"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 暂无求职期望")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("立即修改")
const _hoisted_9 = {
  key: 1,
  class: "form-item-block"
}
const _hoisted_10 = {
  key: 0,
  style: {"display":"flex","flex-wrap":"wrap"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("全职")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("兼职")
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  style: {"text-align":"right","margin":"10px 0 20px"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_v_preview_item = _resolveComponent("v-preview-item")!
  const _component_v_preview = _resolveComponent("v-preview")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.isDialog && _ctx.isShowDetail)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "add-action",
              icon: _ctx.EditPen,
              type: "text",
              size: "small",
              onClick: _ctx.editForm
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["icon", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      (
          !_ctx.isDialog &&
          _ctx.isShowDetail &&
          _ctx.form &&
          !_ctx.form.forwardPostType &&
          !_ctx.form.forwardPostName
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _ctx.editForm
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_el_form, {
              "label-position": "top",
              "label-width": "110px",
              ref: "ruleFormRef",
              model: _ctx.form,
              inline: true,
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                (_ctx.isDialog || !_ctx.isShowDetail)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_el_form_item, {
                        label: "求职类型",
                        prop: "jobType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: _ctx.form.jobType,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.jobType) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { label: 1 }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { label: 2 }, {
                                default: _withCtx(() => [
                                  _hoisted_12
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        required: "",
                        label: "工作城市",
                        prop: "forwardLocationIdList"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_cascader, {
                            style: {"width":"100%"},
                            modelValue: _ctx.form.forwardLocationIdList,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.forwardLocationIdList) = $event)),
                            options: _ctx.cityOptions,
                            props: _ctx.cascaderProps,
                            filterable: "",
                            ref: "forwardLocationRef"
                          }, null, 8, ["modelValue", "options", "props"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        required: "",
                        label: "期望职位",
                        prop: "forwardPostName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.forwardPostName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.forwardPostName) = $event)),
                            placeholder: "请输入期望职位"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        required: "",
                        label: "期望行业",
                        prop: "forwardPostType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.forwardPostType,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.forwardPostType) = $event)),
                            placeholder: "请选择期望行业"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industryList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        required: "",
                        label: "薪资最低要求（元/月)",
                        prop: "forwardMinSalary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.forwardMinSalary,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.forwardMinSalary) = $event)),
                            placeholder: "请选择薪资最低要求"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salaryList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        required: "",
                        label: "薪资最高要求（元/月)",
                        prop: "forwardMaxSalary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.forwardMaxSalary,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.forwardMaxSalary) = $event)),
                            placeholder: "请选择薪资最高要求"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salaryList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_v_preview, {
                        itemTopSpace: "5px",
                        "label-width": "130px",
                        style: {"margin":"0 auto"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_preview_item, {
                            width: "50%",
                            label: "期望职位"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.detail?.forwardPostName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_preview_item, {
                            width: "50%",
                            label: "期望行业"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.detail?.forwardPostTypeName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_preview_item, {
                            width: "50%",
                            label: "薪资要求(元/月)"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.detail?.forwardMinSalaryName) + " ~ " + _toDisplayString(_ctx.detail?.forwardMaxSalaryName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_preview_item, {
                            width: "50%",
                            label: "求职类型"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.detail?.jobTypeName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_preview_item, {
                            width: "50%",
                            label: "工作城市"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.detail?.forwardLocation), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            (_ctx.isDialog || !_ctx.isShowDetail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_el_button, {
                    class: "submit-btn",
                    icon: _ctx.Close,
                    type: "primary",
                    plain: "",
                    onClick: _ctx.closeDialogCpt
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["icon", "onClick"]),
                  _createVNode(_component_el_button, {
                    class: "submit-btn",
                    type: "primary",
                    icon: _ctx.Check,
                    loading: _ctx.isLoading,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["icon", "loading"])
                ]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}